import { render, staticRenderFns } from "./ListaOpcoesCaptura.vue?vue&type=template&id=176804ac&"
import script from "./ListaOpcoesCaptura.vue?vue&type=script&lang=js&"
export * from "./ListaOpcoesCaptura.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports